import { useQuery } from "@tanstack/react-query";
import i18n from "i18n";
import { defaultOnError } from "util/conditional/onError";
import useTableFilterContext from "components/common/PaginatedEntityTable/useTableFilterContext";
import { slicesQueryKey } from "components/common/PaginatedEntityTable/slicing/queryKeys";
import useOnRefresh from "components/common/PaginatedEntityTable/useOnRefresh";
import useTableFetchContext from "components/common/PaginatedEntityTable/useTableFetchContext";
const useFetchSlices = (fetchSlices, sliceRenderers) => {
  const {
    searchParams: { sliceCol, query, filters }
  } = useTableFilterContext();
  const { entityTableId, layoutVariant } = useTableFetchContext();
  const { data, isLoading, refetch } = useQuery({
    queryKey: slicesQueryKey(sliceCol, query, filters, entityTableId, layoutVariant),
    queryFn: () => defaultOnError(
      fetchSlices(sliceCol, query, filters).then(
        ({ slices }) => {
          var _a, _b, _c;
          return (_c = (_b = (_a = sliceRenderers == null ? void 0 : sliceRenderers[sliceCol]) == null ? void 0 : _a.extendSlices) == null ? void 0 : _b.call(_a, slices)) != null ? _c : slices;
        }
      ),
      i18n.t("slicing.fetch_failed", { ns: "common" })
    )
  });
  useOnRefresh(refetch);
  return { slices: data != null ? data : [], isLoading, refetchSlices: refetch };
};
export default useFetchSlices;
